import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ITicketChannelAction } from '../../../../models/ticket';
import { UserCompactInfo } from '../../../../models/user';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { namespace } from 'vuex-class';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';

const UserStore = namespace(USER_MODULE_NAMESPACE)
@Component({
  components: {
    'message-item': async () => import('../ticket-chat-message-item/TicketChatMessageItem.vue'),
    'message-time-notif-status': async () => import('../ticket-chat-message-time-notif-status/TicketChatMessageTimeNotifStatus.vue')
  }
})
class TicketChatUploadingMessageTicket extends Vue {

  @Prop({ required: true, type: [Object] })
  source: ITicketChannelAction;

  @UserStore.Getter userInfo: any;

  constructor() {
    super();
  }

  get isOwner(): boolean {
    return this.source['createdBy'] === this.userInfo.id
  }
  get action(): ITicketChannelAction {
    return this.source;
  }

  get isUploading() {
    return this.source['uploaded'] === false
  }
  get coContainerColor(): string {
    return this.isOwner ? 'primary' : 'white';
  }
  get coTextColor(): string {
    return this.isOwner ? 'white--text' : 'primary--text';
  }
  get coSentAt(): string {
    return DateTimeHelper.parseTimeWithoutUtc(this.source.createdAt);
  }
  getFullName(obj: any): string {
    if (obj)
      return new UserCompactInfo(obj).fullName;
    return obj;
  }
  documentType(media): string {
    return media.name.substring(media.name.length - 10).split('.')[1].toUpperCase();
  }
}

export default TicketChatUploadingMessageTicket;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-message-uploading/index.ts